import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import walletcoveredbg from "../../../../media/images/walletcoverdbg.svg";
import MobileHeader from "../../../layout/DriverLayout/Header";
import coverImage from "../../../../media/images/headCover.svg";
import BannerBox from "./BannerBox";
import WalletActionBox from "./WalletActions";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import { useAppSelector } from "../../../../hooks/useRedux";
import ChargeWalletBox from "./chargeBox";
import Transactions from "./Transactions";

export default function WalletPage() {
  const { isOpenKeyboard } = useAppSelector((state) => state.setting);
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          //   border: "1px solid gray",
          flex: "1",
          overflow: "hidden",
          backgroundImage: `
              url(${walletcoveredbg})
              `,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MobileHeader
          title={
            <Typography
              sx={{
                fontWeight: 600,
                color: "secondary.main",
                fontSize: 16,
              }}
            >
              کیف پول{" "}
            </Typography>
          }
          hasScroll={false}
        />
        <Box
          ref={divRef}
          sx={{
            flex: "1",
            position: "relative",
            display: "flex",
            // border: "1px solid gray",
            overflow: "auto",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              paddingX: "8px",
            }}
          >
            <BannerBox />
            <WalletActionBox
              activeTab={tabIndex}
              getTabIndex={(tabIndex) => {
                setTabIndex(tabIndex);
              }}
            />
            <ChargeWalletBox show={tabIndex === 1} />
          </Box>

          <Transactions show={!(tabIndex === 1)} />
        </Box>
      </Box>
      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}
